module.exports = __webpack_public_path__ + "img/nokrash_blade.f9868bdf.png";